module.exports = __webpack_public_path__ + "img/horizontal_7_2_pp2_8019.5711e435.png";